var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "shareSetting"
  }, [_c('div', {
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "shareResolution"
  }, [_c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('commonSetting.resolution')) + " ")]), _c('el-select', {
    attrs: {
      "popper-class": "setResolution"
    },
    on: {
      "change": _vm.updateBitrate
    },
    model: {
      value: _vm.resolution,
      callback: function ($$v) {
        _vm.resolution = $$v;
      },
      expression: "resolution"
    }
  }, _vm._l(_vm.resolutionOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1)]), _c('div', {
    staticClass: "shareResolution"
  }, [_c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('commonSetting.framerate')) + " ")]), _c('el-select', {
    attrs: {
      "popper-class": "setResolution"
    },
    on: {
      "change": _vm.updateBitrate
    },
    model: {
      value: _vm.ratesValue,
      callback: function ($$v) {
        _vm.ratesValue = $$v;
      },
      expression: "ratesValue"
    }
  }, _vm._l(_vm.ratesOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.showDefault(item.value),
        "value": item.value
      }
    });
  }), 1)], 1)]), _c('div', {
    staticClass: "bitrate"
  }, [_c('div', {
    staticClass: "bitrateTitle"
  }, [_vm._v(_vm._s(_vm.$t('commonSetting.bitrate')))]), _c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "min": 200,
      "max": 10000
    },
    on: {
      "input": _vm.changeBitrateInputValue
    },
    model: {
      value: _vm.bitrate,
      callback: function ($$v) {
        _vm.bitrate = $$v;
      },
      expression: "bitrate"
    }
  }), _c('el-input', {
    attrs: {
      "debounce": "2000",
      "maxlength": 5,
      "show-input-controls": false
    },
    on: {
      "change": _vm.changeBirateVal,
      "input": _vm.asyncBitrateVal
    },
    model: {
      value: _vm.inputBitrateValue,
      callback: function ($$v) {
        _vm.inputBitrateValue = $$v;
      },
      expression: "inputBitrateValue"
    }
  }), _c('i', {
    staticClass: "kbps"
  }, [_vm._v("kbps")])], 1), _c('div', {
    staticClass: "save"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('setting.nextUse')))]), _c('el-button', {
    staticClass: "green",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.submitSetting
    }
  }, [_vm._v(_vm._s(_vm.$t('invite.saveInvite')))])], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };